import { Injectable } from '@angular/core';
import { TuiAlertService } from '@taiga-ui/core';
import { TuiFileLike } from '@taiga-ui/kit';
import { AbstractControl, ValidationErrors } from '@angular/forms';

@Injectable({
  providedIn: 'root',
})
export class CommonService {
  constructor(private alerts: TuiAlertService) {}

  showSuccessAlert(message: string) {
    this.alerts
      .open(message, {
        label: 'Succès',
        appearance: 'success',
        autoClose: 10000,
      })
      .subscribe();
  }

  showErrorAlert(message: string, label: string = 'Erreur') {
    this.alerts
      .open(message, {
        label: label,
        appearance: 'error',
        autoClose: 10000,
      })
      .subscribe();
  }

  convertFileToBase64(file: Blob): Promise<string> {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onloadend = () => {
        resolve(reader.result as string);
      };
      reader.onerror = reject;
      reader.readAsDataURL(file as Blob);
    }).then((file) => {
      return this.removePdfBase64Prefix(file as string);
    });
  }

  removePdfBase64Prefix(input: string): string {
    if (!input) {
      return '';
    }
    const prefix = 'data:application/pdf;base64,';
    return input.startsWith(prefix) ? input.replace(prefix, '') : input;
  }
  removePngBase64Prefix(input: string | undefined): string {
    if (!input) {
      return '';
    }
    const prefix = 'data:image/png;base64,';
    return input.startsWith(prefix) ? input.replace(prefix, '') : input;
  }

  removeAccentsAndToUpper(input: string): string {
    if (!input) {
      return '';
    }
    // Convert to uppercase and remove accents
    return input
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .toUpperCase();
  }

  integerValidator(control: AbstractControl): ValidationErrors | null {
    const value = control.value;
    if (value === null || value === '') {
      return null; // No error for empty input
    }
    return Number.isInteger(+value) ? null : { notInteger: true };
  }
}
